/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { PlanService } from '../services/plan.service';

const planState = {
  managePlanLink: null,
  checkoutLink: null,
  plans: [],
};

const mutations = {
  setCheckoutLink(state, data) {
    state.checkoutLink = data;
  },
  setManagePlanLink(state, data) {
    state.managePlanLink = data;
  },
  setPlans(state, plans) {
    state.plans = plans;
  },
};

const getters = {
  managePlanLink: state => state.managePlanLink,
  checkoutLink: state => state.checkoutLink,
  plans: state => state.plans,
};

const actions = {
  getPlans: async ({ commit }) => {
    try {
      const plans = await PlanService.getPlans();
      commit('setPlans', plans);
      return true;
    } catch (e) {
      return false;
    }
  },
  getCheckoutLink: async (
    { commit },
    {
      plan, billingInterval, currency, trial, success_path, cancel_path,
    },
  ) => {
    try {
      const resp = await PlanService.getCheckoutLink(
        plan,
        billingInterval,
        currency,
        trial,
        success_path,
        cancel_path,
      );
      commit('setCheckoutLink', resp.url);
      return true;
    } catch (e) {
      return false;
    }
  },

  getManagePlanLink: async ({ commit }, returnPath) => {
    try {
      const resp = await PlanService.getManagePlanLink(returnPath);
      commit('setManagePlanLink', resp.url);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: planState,
  mutations,
  getters,
  actions,
};
